import { useEffect, useState } from 'react'
import { IconBank } from '@holbonkit/icons'

type TBankIconProps = {
    name: string
    url: null | string
}

type TLoadedIcon = {
    source: string
    url: string
}

export const BankIcon = ({ name, url }: TBankIconProps) => {
    const [failedSource, setFailedSource] = useState<null | string>(null)
    const [loadedIcon, setLoadedIcon] = useState<null | TLoadedIcon>(null)

    useEffect(() => {
        if (!url) {
            return
        }

        const controller = new AbortController()
        let objectUrl: string | undefined

        fetch(url, { signal: controller.signal })
            .then((response) => {
                if (!response.ok) {
                    throw new Error(String(response.status))
                }

                return response.text()
            })
            .then((svg) => {
                if (controller.signal.aborted) {
                    return
                }

                objectUrl = URL.createObjectURL(
                    new Blob([svg], { type: 'image/svg+xml;charset=utf-8' }),
                )
                setLoadedIcon({ source: objectUrl, url })
            })
            .catch(() => {
                if (controller.signal.aborted) {
                    return
                }

                setLoadedIcon(null)
            })

        return () => {
            controller.abort()

            if (objectUrl) {
                URL.revokeObjectURL(objectUrl)
            }
        }
    }, [url])

    const source = url && loadedIcon?.url === url ? loadedIcon.source : null

    if (!source || failedSource === source) {
        return <IconBank color='var(--text-and-icon-secondary)' size={24} />
    }

    return (
        <img
            alt={name}
            height={24}
            src={source}
            width={24}
            onError={() => setFailedSource(source)}
        />
    )
}
